// console.log("hello from app.js");

//% Register GSAP plugins for Global use
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

//!---------- Get store and process user IP / Location ----------
getLocation();
//# Fn to get user locale data IP / Country Code
async function getLocation() {
  //% Fetch locale data from localStorage
  const locale_data = JSON.parse(localStorage.getItem("locale_data"));

  //% Exit function if locale data is stored in local storage
  if (locale_data?.country_code) {
    // console.log(locale_data.country_code);
    return;
  }

  try {
    const ip_request = await fetch("https://api.ipify.org");
    // console.log(ip_request);
    const ip_address = await ip_request.text();

    const geo_url = `https://api.iplocation.net/?ip=${ip_address}`;
    const geo_request = await fetch(geo_url);

    const geo_data = await geo_request.json();
    // console.log(geo_data);

    const locale_data = {};
    if (geo_data?.response_code === "200") {
      //$ Save data to object
      locale_data.ip_address = geo_data.ip;
      locale_data.country_code = geo_data?.country_code2;
      //$ Store data in localStorage
      localStorage.setItem("locale_data", JSON.stringify(locale_data));
    } else {
      throw new Error("Unable to get location");
    }
  } catch (error) {
    // console.error(error);
  }
}

const scrollWrapper = document.getElementById("scroll-wrapper");

//# Check if a smoothScroll wrapper exists, if so, create a smoother from it
if (scrollWrapper) {
  //% Define a Scroll Smoother matching the wrapper and content ID
  let smoother = ScrollSmoother.create({
    wrapper: "#scroll-wrapper",
    content: "#scroll-content",
    smooth: 1,
    effects: true,
  });

  //% Global Events for stopping and starting the scroll
  window.addEventListener("scroll_toggle", () => {
    smoother.paused(!smoother.paused());
  });

  window.addEventListener("scroll_stop", () => {
    smoother.paused(true);
  });

  window.addEventListener("scroll_start", () => {
    smoother.paused(false);
  });

  // smoother.effects("blockquote", {
  //   speed: 1.2,
  // });
  //# If scrollwrapper is not being used on page then block scroll via default
} else {
  //% Global Events for stopping and starting the scroll
  window.addEventListener("scroll_toggle", () => {
    document.documentElement.classList.toggle("no-scroll");
  });

  window.addEventListener("scroll_stop", () => {
    document.documentElement.classList.add("no-scroll");
  });

  window.addEventListener("scroll_start", () => {
    document.documentElement.classList.remove("no-scroll");
  });
}

//!---------- Local Project Helpers ----------